import React, { SyntheticEvent, useState } from "react";
import {
  Table,
  ScrollArea,
  Grid,
  Button,
  Divider,
  ActionIcon,
} from "@mantine/core";
import { Edit, Archive } from "tabler-icons-react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { deleteSubject, getSubjectDetails } from "./queries";
import { Form } from "./form";

const SubjectView = () => {
  const [isOpenForm, setOpenForm] = useState(false);
  const [data, setData] = useState<SubjectProps | null>(null);
  const queryClient = useQueryClient();
  const { mutate: mutDeleteSubject } = useMutation(deleteSubject, {
    onSuccess: (newData) => {
      queryClient.invalidateQueries();
    },
  });

  const { isLoading, data: subjectData = [] } = useQuery(
    "subjects",
    getSubjectDetails,
    {
      staleTime: 60000,
      refetchOnWindowFocus: false,
    }
  );

  const onUpdateData = (payload: SubjectProps) => {
    setData(payload);
    setOpenForm(true);
  };

  const onRestForm = () => {
    setOpenForm(false);
    setData(null);
  };

  const rows =
    subjectData &&
    subjectData.map((row: SubjectProps) => {
      return (
        <tr key={row.id}>
          <td>{row.id}</td>
          <td>{row.name}</td>
          <td>{row.code}</td>
          <td>{row.available_on_registration ? "Yes" : "No"}</td>
          <td>{row.available_on_filter ? "Yes" : "No"}</td>
          <td>{row.isactive ? "Yes" : "No"}</td>
          <td>
            <Grid columns={2}>
              <Grid.Col span={1}>
                <ActionIcon
                  title="Update"
                  onClick={() => onUpdateData({ ...row })}
                >
                  <Edit size={25} strokeWidth={2} color={"green"} />
                </ActionIcon>
              </Grid.Col>
              <Grid.Col span={1}>
                <ActionIcon
                  title="Delete"
                  onClick={() => mutDeleteSubject({ id: Number(row.id) })}
                >
                  <Archive size={25} strokeWidth={2} color={"red"} />
                </ActionIcon>
              </Grid.Col>
            </Grid>
          </td>
        </tr>
      );
    });

  if (isLoading) {
    // TODO loader on data loading
    return null;
  }
  return (
    <>
      <Grid justify={"flex-end"}>
        <Grid.Col lg={1}>
          <Button
            variant="light"
            onClick={(e: SyntheticEvent) => setOpenForm(true)}
          >
            Create
          </Button>
        </Grid.Col>

        <Grid.Col>
          <Divider />
          <ScrollArea
            offsetScrollbars
            style={{ height: 700, padding: 15 }}
            scrollHideDelay={1000}
          >
            <Table
              sx={{ minWidth: 800 }}
              verticalSpacing="xs"
              horizontalSpacing={"xl"}
            >
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Subject Name</th>
                  <th>Subject Code</th>
                  <th>Available On Registration</th>
                  <th>Available On Filter</th>
                  <th>Is Active</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </Table>
          </ScrollArea>
        </Grid.Col>
      </Grid>
      <Form
        isOpenModal={isOpenForm}
        setOpenForm={setOpenForm}
        onReset={onRestForm}
        data={data}
      />
    </>
  );
};

export default SubjectView;
